import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import type { User } from '@paintscout/api'
import React from 'react'
import classNames from 'classnames'
import EstimatorAvatar from '../EstimatorAvatar'
import { useHorizontalWheelScroll } from '../../hooks/useHorizontalWheelScroll'

const useStyles = makeStyles<Theme, { tab: string }>((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: ({ tab }) => (tab === 'map' ? theme.spacing(0, 0.5) : theme.spacing(0.5, 2, 1, 2.5)),
    marginBottom: ({ tab }) => (tab === 'map' ? 0 : theme.spacing(1)),
    overflowX: ({ tab }) => (tab === 'map' ? 'visible' : 'auto'),
    overflowY: ({ tab }) => (tab === 'map' ? 'visible' : 'hidden'),
    gap: ({ tab }) => (tab === 'map' ? theme.spacing(2) : theme.spacing(3)),
    minHeight: ({ tab }) => (tab === 'map' ? 'auto' : '50px')
  },
  avatar: {
    cursor: 'pointer',
    opacity: 0.5,
    flexShrink: 0
  },
  img: {
    marginTop: '5px'
  },
  selectedAvatar: {
    opacity: 1
  }
}))

export interface EstimatorAvatarSelectProps {
  users: (User & { selected?: boolean })[]
  selectedUsers: User[]
  onClick: (user: User, e: React.MouseEvent) => void
  onDoubleClick?: (allUsers: User[]) => void
  userPictures: Record<string, string>
  tab?: string
}

export default function EstimatorAvatarSelect(props: EstimatorAvatarSelectProps) {
  const { users, selectedUsers, userPictures, onClick, onDoubleClick, tab } = props
  const classes = useStyles({ tab })
  const wheelScrollRef = useHorizontalWheelScroll<HTMLDivElement>()

  return (
    <div ref={wheelScrollRef} className={classes.root}>
      {(users || []).map((user) => {
        return (
          <span
            key={user.user_id}
            className={classNames({
              [classes.avatar]: true,
              [classes.selectedAvatar]: selectedUsers.some((u) => u.user_id === user.user_id)
            })}
            onClick={(e) => onClick(user, e)}
            onDoubleClick={() => onDoubleClick?.(users)}
          >
            <EstimatorAvatar
              classes={{ img: classes.img }}
              userPictures={userPictures}
              user={{
                id: user.user_id,
                firstName: (user.name ?? '').split(' ')[0],
                lastName: (user.name ?? '').split(' ')[1]
              }}
              borderColor={user.user_metadata?.color}
            />
          </span>
        )
      })}
    </div>
  )
}
